<template>
    <div class="prices-page" style="direction: rtl; text-align: right; padding-top: 70px;">
      <Header pageTitle="عروض الأسعار" />
  
      <!-- شاشة التحميل -->
      <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
  
      <!-- المحتوى -->
      <div v-else>
        <div class="container">
          <!-- في حال لم يكن هناك عروض -->
          <div v-if="quotations.length === 0" class="text-center mt-4">
            <p>لا يوجد عروض.</p>
          </div>
  
          <!-- عرض البطاقات -->
          <div v-else>
            <div
              v-for="(quotation) in quotations"
              :key="quotation.quotation_id"
              class="card mb-3 p-3 shadow-sm"
            >
              <!-- رأس الكارد: صورة المستخدم واسم المستخدم ورقم العرض -->
              <div class="d-flex align-items-center">
                <img
                  :src="quotation.users_image ? userImageURL(quotation.users_image) : defaultUserImage"
                  alt="صورة المستخدم"
                  class="rounded-circle me-3"
                  style="width: 50px; height: 50px; object-fit: cover;"
                />
                <div class="me-2">
                  <h5 class="mb-0">{{ quotation.users_name }}</h5>
                  <small class="">رقم العرض: #{{ quotation.quotation_id }}</small>
                </div>
              </div>
  
              <!-- السعر والمدة -->
              <div class="d-flex align-items-center justify-content-around my-3">
                <div class="price-box text-center">
                  <p class="mb-1 ">السعر</p>
                  <h4 class="mb-0" style="color: #e08600;">{{ quotation.quotation_price }} $</h4>
                </div>
                <div class="days-box text-center">
                  <p class="mb-1 ">المدة</p>
                  <h4 class="mb-0" style="color: #296080;">{{ quotation.quotation_numday }} أيام</h4>
                </div>
              </div>
  
              <!-- الوصف -->
              <p class="">{{ quotation.quotation_description }}</p>
  
              <!-- زر الموافقة على العرض أو إظهار حالة الموافقة -->
              <div class="text-end">
                <!-- مثال إذا أردت زر "موافقة" -->
                <button
                  v-if="!quotation.approved"
                  class="btn btn-success"
                  @click="approveQuotation(quotation.quotation_id)"
                >
                  الموافقة على العرض
                </button>
                <!-- أو نص "تمت الموافقة على العرض" -->
                <div v-else class="alert alert-success mb-0">
                  <i class="bi bi-check-circle-fill me-1"></i>
                  تمت الموافقة على العرض
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <Footer />
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Header from '../../components/header.vue';
  import Footer from '../../components/footer.vue';
  
  export default {
    name: 'PricesPage',
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        quotations: [],     // سيُخزن هنا بيانات العروض
        loading: true,      // للتحكم في شاشة التحميل
        defaultUserImage: 'assets/images/avatar/default-avatar.jpg'  // صورة افتراضية
      };
    },
    mounted() {
      // التقاط المعرف من البارام (id)
      const postId = this.$route.params.id;
      // جلب العروض
      this.fetchQuotations(postId);
    },
    methods: {
      // جلب عروض الأسعار للمنشور
      async fetchQuotations(postId) {
        try {
          const response = await axios.post(
            'https://zadcodeonline.com/ahmad/etqan/backEnd/quotation/view_qut_post.php',
            { postsid: postId },
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
  
          if (response.data.status === 'success') {
            this.quotations = response.data.data;
          } else {
            console.error('فشل في جلب العروض:', response.data);
          }
        } catch (error) {
          console.error('خطأ في جلب العروض:', error);
        } finally {
          this.loading = false;
        }
      },
  
      // تكوين رابط الصورة
      userImageURL(imageName) {
        return `https://zadcodeonline.com/ahmad/etqan/backEnd/upload/profile/${imageName}`;
      },
  
      // الموافقة على العرض (مثال)
      approveQuotation(quotationId) {
        // يمكنك وضع منطق الموافقة على العرض هنا
        // مثلًا إرسال طلب للسيرفر أو تحديث الحالة
        const q = this.quotations.find(q => q.quotation_id === quotationId);
        if (q) {
          q.approved = true;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .card {
    border-radius: 15px;
    border: 1px solid #eee;
  }
  
 .days-box {
    background-color: #cbe8f9;
    color: #296080;
    border-radius: 10px;
    border: 2px solid #296080;
}

.price-box {
    background-color: #ebcc9d;
    color: #e08600;
    border-radius: 10px;
    border: 2px solid #e08600;
  }

  .price-box, .days-box {

    width: 100px;
  }
  
  .btn {
    border-radius: 10px;
  }
  </style>
  